export default __webpack_public_path__ + "static/media/meterreading-5.a8ec3e65.png";